<template>
	<div class="card">
		<div class="columns column12">
			<h3>{{ item.header }}</h3>
			<div class="review-score">
				<font-awesome-icon
					v-for="(icon, index) in ratingToStars(item.rating)"
					:key="`${item.ID}-${icon}-${index}`"
					:icon="`fa ${icon}`"
					size="1x"
				/>
			</div>
			<p>{{ item.content }}</p>
			<div class="review-source">
				<strong>{{ item.firstName }}</strong>
				<span v-if="item.date">
					{{ $d(new Date(item.date.date.split(' ')[0]), 'short', locale) }}
				</span>
				<div class="logo" :class="item.source" />
			</div>
		</div>
	</div>
</template>

<script setup>
const { locale } = useI18n();

defineProps({
	item: { type: Object, default: () => {} },
});

const ratingToStars = (rating) => {
	const fullStars = parseInt(rating / 2, 10);
	const result = Array(fullStars).fill('fa-star');

	if ((rating / 2) % 1 !== 0) {
		result.push('fa-star-half');
	}

	return result;
};
</script>

<style lang="scss" scoped>
.card {
	h3 {
		font-size: 24px;
		margin-bottom: 10px;
	}

	.review-score {
		color: #ebd726;
		margin: 0 0 10px;

		i,
		svg {
			padding: 0 3px 0 0;
		}
	}

	.icon-big {
		color: var(--cta-color);
		font-size: 60px;
		margin: 20px auto;
	}

	.review-source {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 15px;
		margin: 34px 0 0;

		img {
			max-width: 30px;
			margin: -5px 0 0 10px;
		}

		.logo {
			width: 30px;
			height: 30px;
			background-size: 30px 30px;

			&.tripadvisor {
				background-image: url('~/assets/images/review-logo-tripadvisor.png');
			}

			&.bookingcom {
				background-image: url('~/assets/images/review-logo-bookingcom.png');
			}

			&.zoover {
				background-image: url('~/assets/images/review-logo-zoover.png');
			}

			&.expedia {
				background-image: url('~/assets/images/review-logo-expedia.png');
			}

			&.google {
				background-image: url('~/assets/images/review-logo-google.png');
			}
		}
	}
}
</style>
